import { Injectable, inject } from '@angular/core';

import { LocalStorageService } from 'src/app/shared/services/local-storage.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  localStorageService = inject(LocalStorageService);

  get isAuthenticated(): boolean {
    return !!this.localStorageService.token?.key;
  }
}
